import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';

export default class PasswordStrengthBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            score: null,
        };
    }

    componentDidMount() {
        this.setScore();
    }

    componentDidUpdate(prevProps) {
        const { password } = this.props;
        if (prevProps.password !== password) {
            this.setScore();
        }
    }

    setScore = () => {
        const { password, minLength, onChangeScore } = this.props;
        let result = null;
        let score = 0;
        import('zxcvbn').then(({ default: zxcvbn }) => {
            if (password.length >= minLength) {
                result = zxcvbn(password);
                ({ score } = result);
            }
            this.setState({ score }, () => {
                if (onChangeScore) onChangeScore(score);
            });
        });
    };

    render() {
        const { password, barColors, scoreWords, minLength, shortScoreWord } = this.props;
        const { score } = this.state;
        let newShortScoreWord = shortScoreWord;
        if (password.length >= minLength) {
            newShortScoreWord = scoreWords[score];
        }

        return (
            score !== null && (
                <div className="password-strength">
                    <div className="password-strength__wrapper">
                        {[1, 2, 3, 4].map((el) => (
                            <Fragment key={`password-strength-bar-item-${el}`}>
                                {el > 1 && <div className="password-strength__space" />}
                                <div
                                    className="password-strength__item"
                                    data-testid={el}
                                    style={{
                                        backgroundColor: score >= el ? barColors[score] : barColors[0],
                                    }}
                                />
                            </Fragment>
                        ))}
                    </div>
                    <p className="password-strength__desc" style={{ color: barColors[score] }}>
                        {newShortScoreWord}
                    </p>
                </div>
            )
        );
    }
}

PasswordStrengthBar.defaultProps = {
    password: '',
    barColors: ['#ddd', '#ef4836', '#f6b44d', '#2b90ef', '#25c281'],
    scoreWords: ['Weak', 'Weak', 'Okay', 'Good', 'Strong'],
    minLength: 4,
    shortScoreWord: 'Too short',
    onChangeScore: undefined,
};

PasswordStrengthBar.propTypes = {
    password: PropTypes.string,
    barColors: PropTypes.array,
    scoreWords: PropTypes.array,
    minLength: PropTypes.number,
    shortScoreWord: PropTypes.string,
    onChangeScore: PropTypes.func,
};
